
  import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
  import {
    Action,
    Getter,
  } from 'vuex-class';
  import Card from '@/components/material/Card.vue';
  import DatePicker from '@/components/date-picker.vue';
  import TimePicker from '@/components/TimePicker.vue';

  @Component({
    components: {TimePicker, DatePicker, Card},
  })
  export default class EventDetails extends Vue {
    public $refs!: {
      form: any,
    };
    @Prop({type: Object, default: null}) private event!: any;

    @Action('admin/events/update') private updateEvent!: (params: any) => Promise<any>;
    @Action('admin/companies/read') private readCompanies!: () => Promise<any>;

    @Getter('common/rules/all') private rules!: any;
    @Getter('admin/companies/all') private companies!: any;

    private loading: boolean = false;
    private localEvent: any = {};
    private valid: boolean = false;
    private deadlineDate: string = '';
    private deadlineTime: string = '';
    private date: string = '';
    private time: string = '';

    private async mounted() {
      this.loading = true;
      await this.readCompanies();

      const deadline = new Date(this.event.deadline);
      const date = new Date(this.event.date);
      this.deadlineDate = `${deadline.getDate()}.${deadline.getMonth() + 1}.${deadline.getFullYear()}`;
      this.date = `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`;
      this.deadlineTime = `${deadline.getHours()}:${(deadline.getMinutes() < 10 ? '0' : '')}${deadline.getMinutes()}`;
      this.time = `${date.getHours()}:${(date.getMinutes() < 10 ? '0' : '')}${date.getMinutes()}`;
      this.localEvent = JSON.parse(JSON.stringify(this.event));
      if (!this.localEvent.description) {
        this.localEvent.description = '';
      }
      this.loading = false;
    }

    private async update() {
      if (this.$refs.form.validate()) {
        this.loading = true;

        const deadlineDate = this.deadlineDate.split('.').map((e: string) => parseInt(e, 10));
        const deadlineTime = this.deadlineTime.split(':').map((e: string) => parseInt(e, 10));
        this.localEvent.deadline =
          new Date(deadlineDate[2], deadlineDate[1] - 1, deadlineDate[0], deadlineTime[0], deadlineTime[1]);

        const trainingDate = this.date.split('.').map((e: string) => parseInt(e, 10));
        const trainingTime = this.time.split(':').map((e: string) => parseInt(e, 10));
        this.localEvent.date =
          new Date(trainingDate[2], trainingDate[1] - 1, trainingDate[0], trainingTime[0], trainingTime[1]);

        await this.updateEvent(this.localEvent);
        this.$emit('updated', true);
        this.loading = false;
      }
    }
  }
